import { Controller } from "@hotwired/stimulus"

// Toggles the NegotiAge header's collapsed nav on narrow screens.
export default class extends Controller {
  static targets = ["toggler", "panes"]

  toggle() {
    this.togglerTarget.classList.toggle("activated")
    this.panesTarget.classList.toggle("visible")
  }
}
